import clsx from "clsx";

import NewsSlider from "../news-slider";

import styles from "./meet-our-clients.module.scss";

const MeetOurClients = ({ showLogos = true, data = {} }) => {
  const { title = "", description = "", articlesCollection = { items: [] }, logosCollection = { items: [] } } = data;

  const filteredPosts = articlesCollection.items.map((post) => ({
    ...post,
    byline: post.category
  }));

  return (
    <div className={clsx("container", styles.MeetOurClients)}>
      <h2>{title}</h2>

      <p>{description}</p>

      <NewsSlider posts={filteredPosts} />

      {showLogos && (
        <div className={styles.LogoList}>
          {logosCollection.items.map((logo, index) => (
            <div key={`${index}_${logo.name}`} className={styles.LogoImage}>
              <img src={`${logo.url}?w=300&fm=webp&q=80`} alt={logo.description} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MeetOurClients;
